import { InvoiceExportApiParameter, InvoiceExportModel, getExportFile } from "@NA/Services/ADIInvoiceExport";
import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import {
    HasOnComplete,
    HasOnSuccess,
    createHandlerChainRunnerOptionalParameter,
} from "@insite/client-framework/HandlerCreator";

type HandlerType = CustomApiHandler<InvoiceExportApiParameter & HasOnSuccess & HasOnComplete, InvoiceExportModel>;

export const CreateExportFile: HandlerType = async (props: any) => {
    props.apiResult = await getExportFile(props.parameter);
};

export const DownloadExportFile: HandlerType = async (props: any) => {
    const fileName = props.apiResult.result;
    const uri = `/api/v1/export/GetFile?file=${fileName}`;
    window.location.href = uri;
    props.apiResult.result = fileName;
};

export const chain = [CreateExportFile, DownloadExportFile];

const invoiceExportHandler = createHandlerChainRunnerOptionalParameter(chain, {}, "InvoiceExportHandler");
export default invoiceExportHandler;
